import * as I18n from 'circe/I18n';

import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/REPORT`;

export const REDUCER_NAME = 'report';

export const SHIPPER_REDUCER_NAME = 'reportShipper';
export const CUSTOM_DATE_FORM_NAME = 'CUSTOM_DATE_FORM';

export const SHIPPER_LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shippers`;

export const ROUTES = {
  ROOT: '/shipper/:shipperId/shipmentsReport',
};

export const REPORTING_PERIODS = {
  '7_DAYS': {
    label: I18n.str('past7Days', 'Past 7 Days'),
    value: 7,
    code: '7_DAYS',
  },
  '14_DAYS': {
    label: I18n.str('past14Days', 'Past 14 Days'),
    value: 14,
    code: '14_DAYS',
  },
  '30_DAYS': {
    label: I18n.str('past30Days', 'Past 30 Days'),
    value: 30,
    code: '30_DAYS',
  },
  OTHER: {
    label: I18n.str('otherDates', 'Other Dates'),
    value: 'OTHER',
    code: 'OTHER',
  },
};
